import translations from '@/translations/translations.json'

export default {
  availableLanguages: {
    en_GB: 'English',
    da_DA: 'Dansk'
  },
  // shouldn't defaultLanguage fallback to availableLanguages[0]?
  defaultLanguage: localStorage.language ? localStorage.language : 'da_DA',
  // languageVmMixin: {
  //   computed: {
  //     currentKebabCase: function () {
  //       return this.current.toLowerCase().replace('_', '-')
  //     },
  //   },
  // },
  // silent: true,
  translations: translations
}
